export enum ActivityEventTypesEnums {
  APPLY = 1,
  NOTE = 2,
  MOVE = 3,
  DELETE_NOTE = 4,
  EMAIL = 40,
}
